import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Form } from "react-bootstrap";
import { getDataAPI } from "../../../services/apiWrapper";
import { ALERT } from "../../../store/actions/actionTypes";

/**
 * Council > Placement > Dashboard. Key counts + a simple grouped report
 * (by state / sector / employer).
 */
// Self-contained tile (inline styles) so the admin panel's CSS can't stretch
// the card to full height - the earlier layout used h-100 inside a flex row and
// the cards grew very tall.
const Tile = ({ label, value, color }) => (
  <div
    style={{
      flex: "1 1 180px",
      minWidth: 170,
      maxWidth: 260,
      background: "#fff",
      border: "1px solid #e9ecef",
      borderRadius: 10,
      boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      padding: "16px 18px",
    }}
  >
    <div style={{ color: "#6c757d", fontSize: 13, marginBottom: 6 }}>{label}</div>
    <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.1, color: color || "#2c3e50" }}>{value}</div>
  </div>
);

export default function PlacementDashboard() {
  const dispatch = useDispatch();
  const token = () => localStorage.getItem("adminToken");
  const alert = (payload) => dispatch({ type: ALERT, payload });

  const [s, setS] = useState(null);
  const [by, setBy] = useState("state");
  const [report, setReport] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await dispatch(getDataAPI("admin/placement/dashboard", token()));
        setS(res.data.data);
      } catch (e) { alert({ error: "Could not load dashboard." }); }
    })();
    // eslint-disable-next-line
  }, []);

  const loadReport = async (dim) => {
    setBy(dim);
    try {
      const res = await dispatch(getDataAPI(`admin/placement/report?by=${dim}`, token()));
      setReport(res.data.data || []);
    } catch (e) { alert({ error: "Could not load report." }); }
  };
  useEffect(() => { loadReport("state"); /* eslint-disable-next-line */ }, []);

  return (
    <div className="container-fluid py-4">
      <h4 className="mb-3">Placement &mdash; Dashboard</h4>
      {s && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
          <Tile label="Employers" value={s.employers_total} />
          <Tile label="Pending employers" value={s.employers_pending} color="#d39e00" />
          <Tile label="Live jobs" value={s.jobs_live} color="#28a745" />
          <Tile label="Applications" value={s.applications} />
          <Tile label="Shortlisted" value={s.shortlisted} color="#17a2b8" />
          <Tile label="Selected" value={s.selected} color="#007bff" />
          <Tile label="Joined" value={s.joined} color="#28a745" />
          <Tile label="Verified placements" value={s.verified_placements} color="#28a745" />
          <Tile label="Placement rate" value={`${s.placement_rate}%`} color="#6f42c1" />
        </div>
      )}

      <div className="d-flex align-items-end mt-3 mb-2" style={{ gap: 12 }}>
        <h5 className="mb-0">Report</h5>
        <Form.Control as="select" value={by} onChange={(e) => loadReport(e.target.value)} style={{ width: 180 }}>
          <option value="state">By State</option>
          <option value="sector">By Sector / Trade</option>
          <option value="employer">By Employer</option>
        </Form.Control>
      </div>
      <Table bordered hover responsive size="sm" style={{ maxWidth: 560 }}>
        <thead className="thead-light"><tr><th>{by}</th><th>Applied</th><th>Joined</th></tr></thead>
        <tbody>
          {report.length === 0 && <tr><td colSpan={3} className="text-center text-muted py-2">No data.</td></tr>}
          {report.map((r, i) => (
            <tr key={i}><td>{r.label || "-"}</td><td>{r.applied}</td><td>{r.joined}</td></tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
